import React from "react";
import videojs from "video.js";
import { useAccess } from "./useAccess";
import useAuth from "./useAuth";

/**
 * Set an access token to the requests of the videoJs library
 */
export function useVideoJsAccessToken() {
  const { getToken } = useAuth();
  const { CameraStream } = useAccess();

  React.useEffect(() => {
    async function setVideoJsToken() {
      // Need to add some typings due to the @types package being outdated
      const vjs = videojs as typeof videojs & {
        Vhs: {
          xhr: {
            beforeRequest: (opt: Record<string, unknown>) => unknown;
          };
        };
      };

      try {
        const token = await getToken();
        vjs.Vhs.xhr.beforeRequest = (options) => {
          const opt = { ...options } as { headers: Record<string, string> };
          if (!opt.headers) {
            opt.headers = {};
          }
          opt.headers.Authorization = `Bearer ${token}`;
          return opt;
        };
      } catch (error) {
        console.error(`Error setting VideoJS access token, ${error}`);
      }
    }
    if (!CameraStream) return;
    void setVideoJsToken();
  }, [CameraStream, getToken]);
}
